import { Injectable } from '@angular/core';
import { UserService } from '../user-admin/user.service';

@Injectable()
export class ProtocolResolver {
    constructor(private service: UserService) { }

    public async resolve() {
        const protocols = await this.service.getTransferProtocols();
        return protocols;
    }
}
